$(document).ready(function() {
$(".product-form-buttons .shopify-payment-button__button").text("Order Now");
console.log("hello");
});

$(document).ready(function() {
    $(".toggle-btn").on("click", function() {
        var $btn = $(this);
        var $content = $btn.siblings(".more-text");

        $content.slideToggle(); // Smoothly show/hide content
        
        // Update button text based on visibility
        if ($btn.text() === "Read More") {
            $btn.text("Read Less");
        } else {
            $btn.text("Read More");
        }
    });
});
